import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const twoColumnsAside: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(5),
  position: 'sticky',
  top: 0,
  maxWidth: responsive({ 0: '450px', 3: 'applicationMenu' }),
  overflow: 'auto',
  height: 'min-content',
  maxHeight: responsive({ 0: 'unset', 3: 'calc(100vh - 100px)' }),
  pr: responsive({ 0: 0, 4: 2 }),
  '.field__withError': {
    borderLeftColor: 'pallete.error.main',
    borderLeftWidth: '4px',
  },
  '.tabsList': {
    flexShrink: 0,
  },

  '& fieldset': {
    flexShrink: 0,
  },

  '.asidePanel': {
    border: 'none',
    padding: 0,
    m: spacing(0),
    display: 'flex',
    flexDirection: 'column',
    '.fieldErrorMessage': {
      backgroundColor: 'palette.warning.light',
      mb: '0',
      p: '2',
      color: 'palette.text.primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'palette.warning.main',
      borderLeftWidth: '8px',
      paddingLeft: spacing(3),
    },
    '&.responsive': {
      display: responsive({ 0: 'flex', 3: 'none' }),
    },

    '.asidePanel__content, .filtersRender': {
      display: 'grid',
      gridTemplateColumns: responsive({ 0: '1fr', 2: '1fr 1fr' }),
      gap: spacing(3),

      '& > .twoColumns': {
        gridColumn: responsive({ 0: '1', 2: '1/3' }),
        gap: spacing(3),
      },

      '&.filtersRender': {
        gridColumn: responsive({ 0: '1', 2: '1/3' }),
      },
    },
    '.tripleContainer': {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
    },

    legend: {
      pt: spacing(2),
      width: '100%',
      fontWeight: 'bold',
      fontSize: '1.2em',
      mb: spacing(5),
      borderBottom: '1px solid',
      borderBottomColor: 'palette.border.section',
    },

    '.additionalFilter': {
      gap: spacing(3),

      '& > div': {
        width: '100%',
      },
    },

    '& label': {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',

      'input,select': {
        width: '100%',
      },
    },
  },

  hamburguerButton: {
    zIndex: 'menu',
  },
  '.dateHour__container': {
    width: '70%',
    mr: '3px',
  },
  '.hourInput__container': {
    width: '32%',
  },
  '.hourInput': {
    height: '50px',
    ml: '3px',
    display: 'block',
    marginBottom: '0.625em',
    outlineOffset: '3px',
    padding: '0.45em 0.45em 0.45em 0.65em',
    width: '95% !important',
  },
  hamburguerMenu: {
    background: 'palette.background.paper',
    p: spacing(7),
    border: '1px solid',
    borderColor: 'palette.border.article',
    zIndex: 'menu',
    '.requiredFilter__Border': {
      borderLeftStyle: 'solid',
      borderLeftWidth: '4px',
      borderLeftColor: 'palette.error.main',
    },
    '.field__withError': {
      borderLeftStyle: 'solid',
      borderLeftWidth: '4px',
      borderLeftColor: 'danger',
    },
    '.ApplicationMenu': {
      width: 'applicationMenu',
    },
  },

  floatingResponsive: {
    position: 'fixed',
    top: 0,
    transition: 'top 0.3s',
    width: '100%',
    zIndex: 'menu',

    '&.hidden': {
      top: '-100%',
    },

    '.floatingMenu__content': {
      '& > div': {
        width: '100%',
        px: 7,
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
      },

      '.ApplicationMenu': {
        maxWidth: 'applicationMenu',
        width: '100%',
        px: 0,
        mx: 'auto',
        maxHeight: '95vh',
        overflow: 'auto',
      },
    },
  },

  bodyAside: {
    background: 'palette.background.paper',
    p: spacing(7),
    mx: 'auto',

    '& > .ApplicationMenu': {
      mx: 'auto',
      maxWidth: 'applicationMenu',
      width: '100%',
    },
  },
};

export default twoColumnsAside;
